// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"82":"3b6572115f8fe66a","87":"47218ad948b6a5dd"}[chunkId] + ".js";
};